<app-open-parameters-atom
  *ngIf="parameters?.length"
  [items]="parameters"
  [iconBackgroundColor]="iconBackgroundColor"
  [iconColor]="iconColor"
  [textColor]="textColor"
  (click)="openParametersModal()"
></app-open-parameters-atom>
